import { Button, Typography } from '@/core/ui';
import { cn } from '@/lib/utils';
import { useAppDispatch } from '@/store';
import { setPresident } from '@/store/history';
import type { IPicture } from '@/types';
import { useTranslation } from 'react-i18next';

interface IProps extends React.ComponentProps<'div'> {
  name: string;
  link: boolean;
  image: IPicture;
  start_date: Date | string | null;
  end_date: Date | string | null;
  presidentId: number;
}

export const PresidentCard = ({
  image,
  presidentId,
  name,
  start_date,
  end_date,
  link,
  className,
}: IProps) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const onMemberClick = () => {
    dispatch(setPresident({ id: presidentId }));
  };

  const formatDate = (date: Date | string | null) => {
    if (!date) return '';
    const d = new Date(date);
    return d.toLocaleDateString('pt-PT', {
      year: 'numeric',
    });
  };

  return (
    <div
      className={cn(
        'flex flex-col justify-between items-center relative overflow-hidden',
        'w-[237px] h-[310px] rounded-[16px] p-[30px]',
        className
      )}
      style={{
        backgroundColor: '#E6F5F1',
        backgroundImage:
          'linear-gradient(to top, #E6F5F1 60%, #E6F5F1 70%, rgba(80, 155, 133, 0.5) 100%)',
      }}
    >
      <img
        src="background/president-bg.png"
        alt="decorative"
        className="absolute top-0 left-0 w-full h-[170px] object-cover pointer-events-none"
      />

      <img
        src={image.path || '/default.png'}
        alt={image.caption || ''}
        className="bg-chalk rounded-full border w-[134px] h-auto object-cover z-10 shadow-[0px_1.59px_29.72px_0px_#231F2033]"
      />

      <div className="flex flex-col space-y-2 h-full justify-evenly w-full z-10 mt-3">
        <Typography
          className={cn(
            'text-black w-full text-[21px] text-center wrap-break-word leading-[19.5px] uppercase font-bold tracking-[0.97px]'
          )}
        >
          {name}
        </Typography>
        <Typography
          className={cn(
            'text-black w-full text-[18px] font-semibold text-center wrap-break-word leading-[17px] tracking-[0.86px]'
          )}
        >
          {start_date ? formatDate(start_date) : ''} -{' '}
          {end_date ? formatDate(end_date) : 'Atualidade'}
        </Typography>
        {link && (
          <Button
            onClick={onMemberClick}
            className="w-full h-[42px] rounded-[777px] bg-danger flex justify-center items-center"
          >
            <Typography className="text-white uppercase text-[19px]">
              {t('history.member.view_biography')}
            </Typography>
          </Button>
        )}
      </div>
    </div>
  );
};
